import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule} from '@angular/forms';

import { LoginRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './pages/core/login/login.component';
import { ServiceErrorComponent } from './pages/core/service-error/service-error.component';
import { ApiService } from './handlers/apiHandler.service';
import { NavComponent } from './pages/core/navigation/nav.component';
import { BreadCrumbComponent } from './components/bread-crumb/bread-crumb.component';


import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { AmbientCirclesComponent } from './components/ambient-circles/ambient-circles';
import { CookieService } from 'ngx-cookie-service';
import { ConfigurationDeactivateGuard } from './handlers/ConfigurationGuard.guard';
import { MaterialIoModule } from './modules/material-io.module';
import { ABCisSharedModule } from './modules/abcis-shared.module';
import { PrimeNgModule } from './modules/prime-ng.module';
import { ResetPasswordComponent } from './pages/core/reset-password/reset-password.component';
import { DropdownModule } from 'primeng/dropdown';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ServiceErrorComponent,
    NavComponent,
    BreadCrumbComponent,
    AmbientCirclesComponent,
    ResetPasswordComponent,
  ],
  imports: [
    MaterialIoModule,
    ABCisSharedModule,
    PrimeNgModule,

    BrowserModule,
    LoginRoutingModule,
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    AngularSvgIconModule,
    FormsModule,
    DropdownModule,
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    ApiService,
    CookieService,
    ConfigurationDeactivateGuard
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
